var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopSocialPinterest = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 22h22V0H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E60019",
  fillRule: "nonzero",
  d: "M11.009 0C4.929 0 0 4.921 0 10.99c0 4.66 2.9 8.64 6.995 10.241-.1-.868-.181-2.207.036-3.157.2-.86 1.287-5.464 1.287-5.464s-.326-.66-.326-1.628c0-1.529.888-2.669 1.993-2.669.942 0 1.396.706 1.396 1.547 0 .941-.598 2.352-.916 3.664-.262 1.094.553 1.99 1.631 1.99 1.958 0 3.462-2.063 3.462-5.03 0-2.632-1.894-4.468-4.603-4.468-3.135 0-4.975 2.343-4.975 4.767 0 .94.363 1.954.816 2.506.09.108.1.208.072.316-.081.344-.272 1.095-.308 1.249-.045.199-.163.244-.371.144-1.378-.642-2.238-2.641-2.238-4.26 0-3.465 2.519-6.65 7.276-6.65 3.814 0 6.786 2.715 6.786 6.351 0 3.79-2.392 6.839-5.708 6.839-1.115 0-2.166-.579-2.52-1.266l-.688 2.614c-.244.959-.915 2.153-1.368 2.886 1.033.316 2.12.488 3.262.488C17.07 22 22 17.079 22 11.01 22.018 4.92 17.089 0 11.009 0"
})))));
export default SvgTiktokDesktopSocialPinterest;